import React, { ChangeEventHandler, MouseEventHandler, ReactElement } from 'react';
import { Params, useParams } from 'react-router-dom';

import { getClassNames } from '../../../../../../utils/util';
import { ARCHIVED, POST_SEARCH_OPTIONS } from '../../../../../../utils/constants';

import { RadioOrSelectOption } from '../../../../../../types/common.types';

import ProfilePicture from '../../../../../common/profile-picture/ProfilePicture';
import Dropdown from '../../../../../common/input/dropdown/Dropdown';

import { ReactComponent as SearchIcon } from '../../../../../../resources/icons/search.svg';

import './tribe-feed-wrapper.scss';

interface Props extends React.PropsWithChildren<unknown> {
  profilePicture?: string;
  status: string;
  onComposeClick?: MouseEventHandler<HTMLButtonElement>;
  searchType?: RadioOrSelectOption;
  onSearchTypeChange: (option: RadioOrSelectOption) => void;
  filterValue: string;
  onFilterValueChange: ChangeEventHandler<HTMLInputElement>;
  onSearchClick: MouseEventHandler<HTMLButtonElement>;
}

const TribeFeedWrapper = ({
  children,
  profilePicture,
  status,
  onComposeClick,
  searchType = POST_SEARCH_OPTIONS[0],
  onSearchTypeChange,
  filterValue,
  onFilterValueChange,
  onSearchClick
}: Props): ReactElement => {
  const { memberExternalReference }: Readonly<Params> = useParams();

  return (
    <div className="tribe-feed-wrapper">
      {!memberExternalReference && (
        <div className="tribe-feed-wrapper__compose">
          <ProfilePicture src={profilePicture} alt="member profile picture" medium />
          <button
            className={getClassNames('tribe-feed-wrapper__compose__button', { disabled: status === ARCHIVED })}
            onClick={onComposeClick}
          >
            <p>Compose...</p>
          </button>
        </div>
      )}
      <div
        className="tribe-feed-wrapper__content"
        id="tribe-feed-wrapper-content"
        data-testid="tribe-feed-wrapper-content"
      >
        <div className="tribe-feed-wrapper__content__header">
          <div className="tribe-feed-wrapper__content__select">
            <p>See</p>
            <Dropdown
              name="post-sort-dropdown"
              value={searchType}
              options={POST_SEARCH_OPTIONS}
              onChange={onSearchTypeChange}
              inline
            />
            <p>first</p>
          </div>
          <div className="tribe-feed-wrapper__filter">
            <input value={filterValue} onChange={onFilterValueChange} data-testid="tribe-filter" />
            <button onClick={onSearchClick} data-testid="search-button">
              <SearchIcon />
            </button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default TribeFeedWrapper;
